import { Button, Card, Col, Divider, Drawer, Flex, Image, Row, Space } from "antd"
import icon from "../../../assets/images/correct.svg"
import { useMediaQuery } from "react-responsive";
import { useLocation, useNavigate } from "react-router-dom";


const useDetail = () => {
    const p3 = "Here is Productdetail"
    const isPortrait = useMediaQuery({ orientation: 'portrait' })
    const navigate = useNavigate();
    const location = useLocation();


    function complete() {
        return (
            <Flex vertical style={{ height: isPortrait ? "85vh" : "97vh", width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                <Row span={22} style={{ textAlign: "center" }}>
                    <Image
                        preview={false}
                        width={isPortrait ? "30vh" : "22vw"}
                        src={icon}
                    />
                </Row>
                <Row style={{ textAlign: "center", height: isPortrait ? "8vh" : "18vh", justifyContent: "center", alignItems: "center" }}>
                    <Flex vertical style={{ color: "#22B348", fontSize: isPortrait ? "2vh" : "2vw", fontWeight: "bold" }}>
                        <span>สัญญาของคุณเสร็จสมบรูณ์</span>
                        <Flex vertical style={{ color: "#909090", fontSize: isPortrait ? "2vh" : "2vw", }}>
                            <span>โปรดรอสักครู่ ก่อนตรวจสอบรายละเอียดสัญญา</span>
                        </Flex>
                    </Flex>
                </Row>
            </Flex>

        )
    }
    function navBar() {


        return (
            <Card style={{
                boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                backgroundColor: "rgba(255, 255, 255, 0.5)",

                width: "100%",
                height: "11vh",
                position: "fixed",
                bottom: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}>
                <Flex style={{ justifyContent: "center", width: "100%" }}>
                    <Button onClick={() => {
                        navigate("/webapp/complete", { state: { txnId: location?.state?.txnId } })
                    }} style={{
                        borderRadius: "4vh",
                        backgroundColor: "#FF9401",
                        borderColor: "#FF9401",
                        width: isPortrait ? "30vh" : "25vw",
                        height: isPortrait ? "5vh" : "7vh",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }}>
                        <span style={{ color: "white", fontSize: isPortrait ? "2vh" : "1.9vw", }}>ดูรายละเอียดสัญญา</span>
                    </Button>
                </Flex>
            </Card>
        )
    }

    return {
        complete,
        navBar,
    }
}
export default useDetail;